// src/components/FeedbackPrompts.jsx
import React from "react";

export const FEEDBACK_PROMPTS = {
  first_level: {
    title: "How was your first level?",
    message:
      "How has your learning experience been after your first level? Any feedback is appreciated — please let us know how it went.",
    linkLabel: "Share feedback",
    href: "https://docs.google.com/forms/d/e/1FAIpQLSevUqT0uywwxIZq56vYHezFzTIiYea5spFoBCDe-QJSGcnBxA/viewform?usp=dialog",
  },
  quest1_complete: {
    title: "Finished Quest 1 🎉",
    message:
      "Congrats on completing Quest 1! We’d love to hear what worked well and what we can improve.",
    linkLabel: "Give feedback for Quest 1",
    href: "https://docs.google.com/forms/d/e/1FAIpQLSctWNahN5r0yU_4bxWfuWrMrVBIQDv5mdFhTNnNhPzeRB9qIw/viewform?usp=dialog",
  },
  // 🔥 NEW: needed by the gate for Quest 3 completion
  quest3_complete: {
    title: "Finished Quest 3 🎉",
    message:
      "Incredible work — you’ve completed Quest 3! We’d love to hear about your experience so far.",
    linkLabel: "Give feedback for Quest 3",
    href: "https://docs.google.com/forms/d/e/1FAIpQLSci0fSi2GiOOaZv-CiHxeNc38dDXwP2pp92ZjR7RGqckTbk-A/viewform?usp=dialog",
  },
};

/** 🔔 Open the feedback modal from anywhere (lesson pages, buttons, etc.) */
export function openFeedbackPrompt(key = "first_level") {
  try {
    window.dispatchEvent(new CustomEvent("open-feedback-prompt", { detail: { key } }));
  } catch {}
}

export function FeedbackModal({ prompt, onClose }) {
  if (!prompt) return null;
  return (
    <div
      className="fixed inset-0 z-[1000] bg-black/40 flex items-center justify-center px-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-[12px] w-full max-w-sm p-4 shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-2">
          <h3 className="text-lg font-bold text-black">{prompt.title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-500 hover:text-black"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <p className="text-sm text-[#555] mb-4">{prompt.message}</p>

        <a
          href={prompt.href}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center w-full bg-black text-white rounded-[10px] py-2.5 text-sm font-bold hover:bg-neutral-800"
        >
          {prompt.linkLabel}
        </a>

        
      </div>
    </div>
  );
}
